export default __webpack_public_path__ + "static/ez-f2540a32a2fef6aa782cffe0404ea166.png";